import { Injectable } from '@angular/core';
import { HttpService } from 'src/app/wrappers/Http';
import { HelperFunctions } from '../helper-functions';
import { TranslateService } from '@ngx-translate/core';
import { ConfigService } from '../config.service';
import { ToolbarSettingsModel } from '@syncfusion/ej2-angular-richtexteditor';
import { SiteInfo, PromotionTranslationRow } from '@model/site-info.model';
import { Navigation, NavMenuTranslationRow } from 'src/app/interface/interfaces';

@Injectable({
  providedIn: 'root'
})
export class PartnerServicesService {
  cagnotte: any[];
  cagnotteCounts: any;
  navMenuList: any[] = [];
  navMenuListCounts: any;
  activeNav: any;
  footerMenuList = [];
  // provider: any;
  public textEditorToolbarOPtions: object = {
    type: 'MultiRow' as ToolbarSettingsModel['type'],
    items: ['CreateTable','Undo', 'Redo', '|',
    'Bold', 'Italic', 'Underline', 'StrikeThrough', '|',
    'FontName', 'FontSize', 'FontColor', 'BackgroundColor', '|',
    'SubScript', 'SuperScript', '|',
    'LowerCase', 'UpperCase', '|',
    'Formats', 'Alignments', '|', 'OrderedList', 'UnorderedList', '|',
    'Indent', 'Outdent', '|', 'CreateLink',
    'Image', '|', 'ClearFormat', 'Print', 'SourceCode', '|', 'FullScreen']
};
public textEditorView = {
  height: 350,  // at-rest height
  minHeight: 300,
  maxHeight: 600,
}
  types = [
    { name: 'promotions', value: 'promotion' },
    { name: 'how-to', value: 'management' },
    { name: 'jeux-collector', value: 'jeux-collector' },
    { name: 'notification', value: 'notification' }
  ];

  notificationTypes = [
    { name: 'new_millionaire_alert', value: 'new-millionaire-alert'},
    { name: 'system_alert', value: 'system-alert'},
    { name: 'new_promotion_alert', value: 'new-promotion-alert'},
  ]

  Navtypes = [{ name: 'footer', value: 'footer' },
  { name: 'others', value: 'others' },
  { name: 'nav', value: 'nav' }];
  menuTypes = ['header', 'footer', 'others'];

  constructor(private httpService: HttpService,
    private configService: ConfigService,
    private helperFunction: HelperFunctions,
    private translate: TranslateService,) {
    this.configService.$config.subscribe(res => {
    });
  }

  ///// Getters and Setters
  public get publications(): Array<any> {
    return this._publications;
  }
  public set publications(value: Array<any>) {
    this._publications = value;
  }
  public get unassignedProducts(): Array<any> {
    return this._unassignedProducts;
  }
  public set unassignedProducts(value: Array<any>) {
    this._unassignedProducts = value;
  }
  public get assignedProducts(): Array<any> {
    return this._assignedProducts;
  }
  public set assignedProducts(value: Array<any>) {
    this._assignedProducts = value;
  }
  public get pTransactions(): Array<any> {
    return this._pTransactions;
  }
  public set pTransactions(value: Array<any>) {
    this._pTransactions = value;
  }
  public get partners(): Array<any> {
    return this._partners;
  }
  public set partners(value: Array<any>) {
    this._partners = value;
  }
  public get providers(): Array<any> {
    return this._providers;
  }
  public set providers(value: Array<any>) {
    this._providers = value;
  }
  public get products(): Array<any> {
    return this._products;
  }
  public set products(value: Array<any>) {
    this._products = value;
  }
  public get productGroups(): Array<any> {
    return this._productGroups;
  }
  public set productGroups(value: Array<any>) {
    this._productGroups = value;
  }
  public get productTypes(): Array<any> {
    return this._productTypes;
  }
  public set productTypes(value: Array<any>) {
    this._productTypes = value;
  }

  public get activePartnerDetails(): any {
    return this._activePartnerDetails;
  }
  public set activePartnerDetails(value: any) {
    this._activePartnerDetails = value;
  }

  public get activepartner(): any {
    return this._activepartner;
  }
  public set activepartner(value: any) {
    this._activepartner = value;
  }


  private _partners: Array<any> = [];
  private _activeBonus: Array<any> = [];
  private _providers: Array<any> = [];
  private _activePartnerDetails: any = {};
  private _activepartner: any;
  private _products: Array<any> = [];
  private _productTypes: Array<any> = [];
  private _pTransactions: Array<any> = [];
  private _productGroups: Array<any> = [];
  private _assignedProducts: Array<any> = [];
  private _unassignedProducts: Array<any> = [];
  private _publications: Array<any> = [];
  eventCounts: any;
  bonusCount:any;
  ptypeCounts: any;
  productCounts: number;
  pgroupCounts: number;
  pTransCount: number;
  slidderDetail: any;
  slidderImages: any;
  publicationCounts: any;
  promotions: any[];
  promotionCounts: any;
  activeSlidder: any;
  sportPromo: SiteInfo[] = [];
  sportPromoCounts: any;
  activePromo = {};
  // tslint:disable-next-line: contextual-lifecycle

  //// Server Requests
  loadPartners(params = {}, more = '') {

    return this.httpService.Hget(this.configService.GATEWAY_ADMIN_, '/partners/all', params).then(response => {
      this.partners = response.data;
      this.eventCounts = response.count;
    });
  }
  loadActivesBonus(params = {}, more = '') {

    return this.httpService.Hget(this.configService.GATEWAY_ADMIN_, '/v1/bonus-consumer-controler/bonus/active/', params)

  }
  loadProviders(params = {}, more = '') {
    return this.httpService.Hget(this.configService.GATEWAY_ADMIN_, '/providers/all', params).then(response => {
      this.providers = response;
    });
  }
  loadProducts(params = {}, more = '') {
    this.productCounts = 0;
    return this.httpService.Hget(this.configService.GATEWAY_ADMIN_, '/products/all', params).then(response => {
      if (response) {
        if (more == 'load-more') {
          this.products = [...this.products, ...response.data];
          this.productCounts = response.count;
        } else {
          this.products = response.data;
          this.productCounts = response.count;
        }
      }
    });

  }
  changeProductStatus(params: {}) {

    return this.httpService.Hget(this.configService.GATEWAY_ADMIN_, '/products/status/change', params);
  }
  loadProductGroups(params = {}, more = '') {
    this.pgroupCounts = 0;
    return this.httpService.Hget(this.configService.GATEWAY_ADMIN_, '/products/groups/all', params).then(data => {
      if (data) {
        if (more == 'load-more') {
          this.productGroups = [...this.productGroups, ...data.data];
          this.pgroupCounts = data.count;
        } else {
          this.productGroups = data.data;
          this.pgroupCounts = data.count;
        }
      }
    });

  }
  loadPartnerTransactions(params, more = '') {
    this.pTransCount = 0;
    return this.httpService.Hget(this.configService.GATEWAY_ADMIN_, '/partners/transactions', params).then(response => {
      if (response) {
        if (more == 'load-more') {
          this.pTransCount = response.count;
          this.pTransactions = [...this.pTransactions, ...response.data];
        } else {
          this.pTransactions = response.data;
          this.pTransCount = response.count;
        }




      }
    });
  }
  loadProductTypes(params = {}, more = '') {
    this.ptypeCounts = 0;
    return this.httpService.Hget(this.configService.GATEWAY_ADMIN_, '/products/types/all', params).then(data => {

      if (data) {
        if (more === 'load-more') {
          this.ptypeCounts = data.count;
          this.productTypes = [...this.productTypes, ...data.data];
        } else {
          this.productTypes = data.data;
          this.ptypeCounts = data.count;
        }
      }
    }).catch(err => {
      // console.log(err);
    });
  }
  editSlidder(id, params: any = {}) {
    return this.httpService.Post(this.configService.GATEWAY_ADMIN_ + '/system/slider/' + id + '/update', params);
  }
  // loadSlidderDetails(id){
  //   return this.httpService.Hget(this.configService.GATEWAY_ADMIN_, 'GET /system/sliders/' + id +'/details', {})
  // }
  loadPromotions(params = {}, more = '') {
    let gw = this.configService.GATEWAY_ADMIN_;
    // let gw = "http://10.12.1.102:9003";
    return this.httpService.Hget(gw, '/system/sliders', params).then(response => {
      if (more === 'load-more') {
        this.promotions = [...this.promotions, ...response.data];
        this.promotionCounts = response.count;
      } else {
        this.promotions = response.data;
        this.promotionCounts = response.count;
      }

    });
  }
  LoadNavigations(params = {}, more = '') {
     let gw = this.configService.GATEWAY_ADMIN_;
    // let gw = "http://10.12.1.102:9003";
    return this.httpService.Hget(gw, '/navigations/list', params).then(response => {
      if (more === 'load-more') {
        // this.navMenuList = [...this.navMenuList, ...response.data.main, ...response.data.others];
        response.data.main ? this.navMenuList = [...this.navMenuList, ...response.data.main] : '';
        response.data.others ? this.navMenuList = [...this.navMenuList, ...response.data.others] : '';

        this.navMenuListCounts = this.navMenuList.length;
      } else {
        // this.navMenuList = [...response.data.main];
        response.data.main ? this.navMenuList = [...response.data.main] : '';
        response.data.others ? this.navMenuList = [...this.navMenuList, ...response.data.others] : '';
        this.navMenuListCounts = this.navMenuList.length;
      }
      // console.log('nav menu lists', this.navMenuList);
    });
  }
  loadNavigationDetails(id, lang: string = '') {
    let gw = this.configService.GATEWAY_ADMIN_;
    // let gw = "http://10.12.1.102:9003";
    const params = lang ? { lang } : {};
    return this.httpService.Hget(gw, '/navigations/' + id + '/full', params);
  }
  loadSportPromotions(params:any = {} as any, more = '') {
    // params['type'] = "";
    let gw = this.configService.GATEWAY_ADMIN_;
    // let gw = "http://10.12.1.102:9003";
    return this.httpService.Hget(gw, '/site_info/all', params).then(response => {
      if (more === 'load-more') {
        this.sportPromo = [...this.sportPromo, ...response.data];
        this.sportPromoCounts = response.count;
      } else {
        this.sportPromo = response.data;
        this.sportPromoCounts = response.count;
      }

    });
  }
  loadSportPromotionDetails(id, lang: string = '') {
    const params = lang ? { lang } : {};
    let gw = this.configService.GATEWAY_ADMIN_;
    // let gw = "http://10.12.1.102:9003";
    return this.httpService.Hget(gw, '/site_info/' + id + '/full', params);
  }
  editSportPromo(id, params: any = {}) {
    // params.append('type', "promotion");
    let gw = this.configService.GATEWAY_ADMIN_;
    // let gw = "http://10.12.1.102:9003";

    return this.httpService.Post(
      `${gw}/site_info/${id}/update`,
      params,
    );
  }
  addSportPromo(params: any = {}) {
    let gw = this.configService.GATEWAY_ADMIN_;
    // let gw = "http://10.12.1.102:9003";
    return this.httpService.Post(gw + '/site_info/add', params);
  }

  buildPromotionFormData(data: any, fallbackLang: string, baseFiles: any = {}, langFiles: any = {}): FormData {
    const formData = new FormData();

    formData.append('fallbackLang', fallbackLang);
    formData.append('name', data.name || '');
    formData.append('status', String(data.status !== undefined ? data.status : true));
    formData.append('type', data.type || '');
    formData.append('position', String(data.position || 0));
    formData.append('startTime', String(data.startDate || data.startTime || 0));
    formData.append('endTime', String(data.endDate || data.endTime || 0));

    if (data.hasOwnProperty('description')) {
      formData.append('description', data.description || '');
    }
    const strCondUtilisation = data.strCondUtilisation || data.str_cond_utilisation;
    if (strCondUtilisation) {
      formData.append('str_cond_utilisation', strCondUtilisation);
    }
    const strConditionObtention = data.strConditionObtention || data.str_condition_obtention;
    if (strConditionObtention) {
      formData.append('str_condition_obtention', strConditionObtention);
    }
    if (data.bonusId) {
      formData.append('bonusId', String(data.bonusId));
    }
    if (data.outlet) {
      formData.append('outlet', data.outlet);
    }
    if (data.channel || data.channels) {
      const channels = Array.isArray(data.channel || data.channels)
        ? (data.channel || data.channels)
        : [data.channel || data.channels];
      formData.append('channels', JSON.stringify(channels));
    }

    this.appendIfPresent(formData, 'image', baseFiles.image);
    this.appendIfPresent(formData, 'promotionFile', baseFiles.promotionFile);

    const translations = (data.translations || [])
      .filter((t: any) => t.lang && t.lang !== fallbackLang)
      .map((t: any) => {
        const copy = { ...t };
        delete copy.imageFile;
        delete copy.promotionFile;
        return copy;
      });
    formData.append('translations', JSON.stringify(translations));

    this.appendLangFiles(formData, 'image', langFiles.image);
    this.appendLangFiles(formData, 'promotionFile', langFiles.promotionFile);

    return formData;
  }

  buildNavMenuFormData(data: any, fallbackLang: string, baseFiles: any = {}, langFiles: any = {}): FormData {
    const formData = new FormData();

    formData.append('fallbackLang', fallbackLang);
    formData.append('name', data.name || '');
    formData.append('type', data.type || '');
    formData.append('status', String(data.status !== undefined ? data.status : true));
    formData.append('position', String(data.position || 0));

    if (data.title) {
      formData.append('title', data.title);
    }
    if (data.content) {
      formData.append('content', data.content);
    }
    if (data.description) {
      formData.append('description', data.description);
    }
    if (data.link) {
      formData.append('link', data.link);
    }
    if (data.channel !== undefined && data.channel !== null) {
      formData.append('channel', Array.isArray(data.channel) ? data.channel.join(',') : String(data.channel));
    }
    if (data.hasOwnProperty('highlight')) {
      formData.append('highlight', String(data.highlight));
    }
    if (data.hasOwnProperty('isLeave')) {
      formData.append('isLeave', String(data.isLeave));
    }
    if (data.hasOwnProperty('newTab')) {
      formData.append('newTab', String(data.newTab));
    }
    if (data.hasOwnProperty('authRequired')) {
      formData.append('authRequired', String(data.authRequired));
    }
    if (data.hasOwnProperty('isCardItem')) {
      formData.append('isCardItem', String(data.isCardItem));
    }
    if (data.parent !== undefined && data.parent !== null) {
      formData.append('parent', String(data.parent));
    }
    if (data.context) {
      formData.append('context', data.context);
    }

    this.appendIfPresent(formData, 'img', baseFiles.img);

    const translations = (data.translations || [])
      .filter((t: any) => t.lang && t.lang !== fallbackLang)
      .map((t: any) => {
        const copy = { ...t };
        delete copy.imgFile;
        return copy;
      });
    formData.append('translations', JSON.stringify(translations));

    this.appendLangFiles(formData, 'img', langFiles.img);

    return formData;
  }

  /**
   * Build the multipart FormData payload for creating/updating a sport promotion.
   * English (`en`) is the fallback/base language: its content is sent as the base
   * fields, while the other languages are sent as a `translations` JSON array.
   * Base files go to `image`/`promotionFile`; per-language files go to
   * `image_<lang>`/`promotionFile_<lang>`. Files omitted on update keep the
   * existing backend value.
   */
  buildSportPromoFormData(base: any, langSpecifics: any = {}, baseFiles: any = {}, langFiles: any = {}): FormData {
    const fallbackLang = 'en';
    const formData = new FormData();
    const fallback = langSpecifics[fallbackLang] || {};

    formData.append('status', String(base.status !== undefined ? base.status : true));
    formData.append('type', base.type || '');
    formData.append('position', String(base.position || 0));
    formData.append('startTime', String(base.startDate || base.startTime || 0));
    formData.append('endTime', String(base.endDate || base.endTime || 0));
    formData.append('name', fallback.name || '');
    formData.append('description', fallback.description || '');
    formData.append('isTopPromotion', String(base.isTopPromotion !== undefined && Boolean(base.isTopPromotion) ? base.isTopPromotion : false));

    if (fallback.condUtilisation) {
      formData.append('str_cond_utilisation', fallback.condUtilisation);
    }
    if (fallback.conditionObtention) {
      formData.append('str_condition_obtention', fallback.conditionObtention);
    }
    if (base.bonusId) {
      formData.append('bonusId', String(base.bonusId));
    }
    if (base.outlet) {
      formData.append('outlet', base.outlet);
    }
    // NOTE: `userId` is appended automatically by the HTTP layer (addUserIdAndLang).
    const channels = base.channel || base.channels;
    if (channels !== undefined && channels !== null) {
      formData.append('channels', JSON.stringify(Array.isArray(channels) ? channels : [channels]));
    }

    const translations = Object.keys(langSpecifics)
      .filter(lang => lang !== fallbackLang)
      .map(lang => {
        const c = langSpecifics[lang] || {};
        const entry: any = { lang };
        entry.name = c.name || '';
        entry.description = c.description || '';
        if (c.condUtilisation) { entry.condUtilisation = c.condUtilisation; }
        if (c.conditionObtention) { entry.conditionObtention = c.conditionObtention; }
        if (c.imageUrl) { entry.imageUrl = c.imageUrl; }
        if (c.promotionFileUrl) { entry.promotionFileUrl = c.promotionFileUrl; }
        return entry;
      })
      .filter(e => e.name || e.description || e.condUtilisation || e.conditionObtention || e.imageUrl || e.promotionFileUrl);
    formData.append('translations', JSON.stringify(translations));

    this.appendIfPresent(formData, 'image', baseFiles.image);
    this.appendIfPresent(formData, 'promotionFile', baseFiles.promotionFile);
    this.appendLangFiles(formData, 'image', langFiles.image);
    this.appendLangFiles(formData, 'promotionFile', langFiles.promotionFile);

    return formData;
  }

  /**
   * Build the multipart FormData payload for creating/updating a navigation menu.
   * English (`en`) is the fallback/base language: its title/content is sent as the
   * base fields, while the other languages are sent as a `translations` JSON array.
   * Base image goes to `img`; per-language images go to `img_<lang>`. An image
   * omitted on update keeps the existing backend value.
   */
  buildNavMenuLangFormData(base: any, langSpecifics: any = {}, baseFiles: any = {}, langFiles: any = {}): FormData {
    const fallbackLang = 'en';
    const formData = new FormData();
    const fallback = langSpecifics[fallbackLang] || {};

    if (base.id !== undefined && base.id !== null) {
      formData.append('id', String(base.id));
    }
    formData.append('lang', fallbackLang);
    formData.append('name', base.name || '');
    formData.append('type', base.type || '');
    formData.append('status', String(base.status !== undefined ? base.status : true));
    formData.append('position', String(base.position || 0));
    formData.append('title', fallback.title || '');
    formData.append('content', fallback.content || '');

    if (base.description) {
      formData.append('description', base.description);
    }
    if (base.link) {
      formData.append('link', base.link);
    }
    if (base.context) {
      formData.append('context', base.context);
    }
    if (base.channel !== undefined && base.channel !== null) {
      formData.append('channel', Array.isArray(base.channel) ? base.channel.join(',') : String(base.channel));
    }
    if (base.hasOwnProperty('highlight')) {
      formData.append('highlight', String(base.highlight));
    }
    if (base.hasOwnProperty('isLeave')) {
      formData.append('isLeave', String(base.isLeave));
    }
    if (base.hasOwnProperty('newTab')) {
      formData.append('newTab', String(base.newTab));
    }
    if (base.hasOwnProperty('authRequired')) {
      formData.append('authRequired', String(base.authRequired));
    }
    if (base.hasOwnProperty('isCardItem')) {
      formData.append('isCardItem', String(base.isCardItem));
    }
    if (base.parent !== undefined && base.parent !== null) {
      formData.append('parent', String(base.parent));
    }
    // NOTE: `userId` is appended automatically by the HTTP layer (addUserIdAndLang).

    const translations = Object.keys(langSpecifics)
      .filter(lang => lang !== fallbackLang)
      .map(lang => {
        const c = langSpecifics[lang] || {};
        const entry: any = { lang };
        entry.title = c.title || '';
        entry.content = c.content || '';
        if (c.imgUrl) { entry.imgUrl = c.imgUrl; }
        return entry;
      })
      .filter(e => e.title || e.content || e.imgUrl);
    formData.append('translations', JSON.stringify(translations));

    this.appendIfPresent(formData, 'img', baseFiles.img);
    this.appendLangFiles(formData, 'img', langFiles.img);

    return formData;
  }

  private appendIfPresent(formData: FormData, key: string, file?: File) {
    if (file) {
      formData.append(key, file);
    }
  }

  private appendLangFiles(formData: FormData, fieldPrefix: string, filesByLang: Record<string, File>) {
    if (!filesByLang) {
      return;
    }
    Object.entries(filesByLang).forEach(([lang, file]) => {
      if (file) {
        formData.append(`${fieldPrefix}_${lang}`, file);
      }
    });
  }

  loadCagnotte(params = {}, more = '') {
    return this.httpService.get('/presentation/sliders', params).then(response => {
      if (more === 'load-more') {
        this.cagnotte = [...this.cagnotte, ...response.data];
        this.cagnotteCounts = response.count;
      } else {
        this.cagnotte = response.data;
        this.cagnotteCounts = response.count;
      }

    });
  }
  loadSlidderDetails(id) {
    let gw = this.configService.GATEWAY_ADMIN_;
    // let gw = "http://10.12.1.185:9003";
    return this.httpService.Hget(gw, '/system/sliders/' + id + '/details', {});
  }
  deleteSlidder(id, param) {
    let gw = this.configService.GATEWAY_ADMIN_;
    // let gw = "http://10.12.1.185:9003";
    return this.httpService._post(gw + '/system/publication/' + id + '/removeImage', param);
  }
  filterPartners(params: any, more = ''): Promise<any> {
    // console.log('params')
    return this.httpService.Hget(this.configService.GATEWAY_ADMIN_, '/partners/all', params).then(response => {
      if (more === 'load-more') {
        this.partners = [...this.partners, ...response.data];
        this.eventCounts = response.count;
      } else {
        this.partners = response.data;
        this.eventCounts = response.count;
      }

    });
  }
  filterProducts(params: any, more = '') {
    return this.httpService.Hget(this.configService.GATEWAY_ADMIN_, '/products/all', params).then(response => {
      if (more === 'load-more') {
        this.products = [...this.products, ...response];
        this.productCounts = response.count;
      } else {
        this.products = response;
        this.productCounts = response.count;
      }

    });
  }
  filterProductTypes(searchdata, type) {
    searchdata.page = 0;
    searchdata.name = searchdata.filter;

    this.loadProductTypes(searchdata);
  }
  filterProductGroups(searchdata, type) {
    searchdata.page = 0;
    searchdata.name = searchdata.filter;

    this.loadProductGroups(searchdata);
  }
  LoadPartnerAssignedProduct(id, params = {}, more = '') {
    return this.httpService.Hget(this.configService.GATEWAY_ADMIN_, '/products/all/' + id, params).then(response => {
      if (more === 'load-more') {
        this.assignedProducts = [...this.assignedProducts, ...response];
        // this.productCounts = response.count;
      } else {
        this.assignedProducts = response;
        // this.productCounts = response.count;
      }

    });
  }
  loadPublication(params = {}, more = '') {
    return this.httpService.Hget(this.configService.GATEWAY_ADMIN_, '/system/publication/list', params).then(response => {
      if (more === 'load-more') {
        this.publications = [...this.publications, ...response.data];
        this.publicationCounts = response.count;
      } else {
        this.publications = response.data;
        this.publicationCounts = response.count;
      }

    });
  }
  loadPublicationDetails(id) {
    return this.httpService.Hget(this.configService.GATEWAY_ADMIN_, '/system/publication/' + id + '/info', {}).then(response => {
      this.slidderDetail = response.data;

    });
  }
  loadPublicationImages(id) {
    return this.httpService.Hget(this.configService.GATEWAY_ADMIN_, '/system/publication/' + id + '/images', {}).then(response => {
      this.slidderImages = response;

    });
  }
  removePublicationImages(id, param) {
    return this.httpService._post(this.configService.GATEWAY_ADMIN_ + '/system/publication/' + id + '/removeImage', param);
  }
  uploadPublicationImages(params, id) {
    return this.httpService.Post(this.configService.MAIN_GATEWAY + '/system/publication/' + id + '/uploadImage', params);
  }
  uploadPartnerImage(param, id) {
    return this.httpService.Post(this.configService.MAIN_GATEWAY + '/partners/' + id + '/uploadImage', param);
  }
  postFile(fileToUpload, id) {
    const endpoint = this.configService.GATEWAY_ADMIN_ + '/system/publication/' + id + '/uploadImage';
    const formData: FormData = new FormData();
    formData.append('fileKey', fileToUpload, fileToUpload.name);
    return this.httpService
      .Post(endpoint, formData);

  }
  getPartnerDeductions(id: any, params = {}) {
    return this.httpService.Hget(this.configService.GATEWAY_ADMIN_, '/deductions/get/' + id, params);

  }
  getPartnershares(id: any) {
    return this.httpService.Hget(this.configService.GATEWAY_ADMIN_, '/share/get/' + id, {});
  }
  getNav(params) {
    let gw = this.configService.GATEWAY_ADMIN_;
    // let gw = "http://10.12.1.102:9003";
    return this.httpService.Hget(gw, '/navigations/list', params);
  }
  editPartnerConfig(params) {
    return this.httpService.Post(this.configService.GATEWAY_ADMIN_ + '/share/updateConfig/', params);
  }
  createPartnerConfig(params: any = {}) {
    return this.httpService.Post(this.configService.GATEWAY_ADMIN_ + '/share/updateConfig', params);

  }
  createPartnerDeductions(params: any = {}) {
    return this.httpService.Post(this.configService.GATEWAY_ADMIN_ + '/deductions/create', params);

  }
  createPartnershares(params: any = {}) {
    return this.httpService.Post(this.configService.GATEWAY_ADMIN_ + '/share/create', params);
  }
  editPartnerDeductions(params: any = {}) {
    return this.httpService.Post(this.configService.GATEWAY_ADMIN_ + '/deductions/update', params);

  }
  editPartnershares(params: any = {}) {
    return this.httpService.Post(this.configService.GATEWAY_ADMIN_ + '/share/update', params);
  }
  addSlidder(params): Promise<any> {
    return this.httpService.Post(this.configService.GATEWAY_ADMIN_ + '/system/slider/add', params);
  }
  addNav(params): Promise<any> {
    // var api = "http://10.12.1.102:9003";
  var api = this.configService.GATEWAY_ADMIN_
    return this.httpService.Post(api+ '/navigations/create', params);
  }
  editNav(params): Promise<any> {
    // var api = "http://10.12.1.102:9003";
  var api = this.configService.GATEWAY_ADMIN_
    return this.httpService.Post(api + `/navigations/edit`, params);
  }
  addCagnotte(params): Promise<any> {
    return this.httpService.Post(this.configService.GATEWAY_ADMIN_ + '/system/slider/add', params);
  }
  newPublication(params) {
    return this.httpService.Post(this.configService.GATEWAY_ADMIN_ + '/system/publication/create', params);
  }
  editPublication(params) {
    return this.httpService.Post(this.configService.GATEWAY_ADMIN_ + '/system/publication/' + params.id + '/update', params);
  }
  LoadPartnerUnAssignedProduct(params, more = '') {
    // let params ={
    //   id : id
    // }
    return this.httpService.Hget(this.configService.GATEWAY_ADMIN_, '/products/unassigned', params).then(response => {
      if (more === 'load-more') {
        this.unassignedProducts = [...this.unassignedProducts, ...response];
        // this.productCounts = response.count;
      } else {
        this.unassignedProducts = response;
        // this.productCounts = response.count;
      }

    });

  }
  addProductToPartner(params) {
    return this.httpService.Post(this.configService.GATEWAY_ADMIN_ + '/products/assign', params);
  }
  removeProductFromProvider(params) {
    return this.httpService.Post(this.configService.GATEWAY_ADMIN_ + '/products/unassign', params);
  }

  changePartnerStatus(params) {
    // console.log('here')
    return this.httpService.Hget(this.configService.GATEWAY_ADMIN_, '/partners/status/change', params);
  }
  createPartner(params) {
    return this.httpService.Post(this.configService.GATEWAY_ADMIN_ + '/partners/new', params);
  }
  createProduct(params) {
    // console.log("here")
    return this.httpService.Post(this.configService.GATEWAY_ADMIN_ + '/products/new', params);

  }
  createProductType(params) {
    return this.httpService.Post(this.configService.GATEWAY_ADMIN_ + '/products/types/new', params);
  }
  //// Global Methods
  async checkOperation(res, index?):Promise<boolean> {
    let trueBtn = false;
    if (res && res.hasOwnProperty('erc') && (res.erc + '') === '1') {
      // tslint:disable-next-line: max-line-length
      if (index) {
        this.slidderImages.splice(index, 1);
      }
      await this.helperFunction.presentAlert('success', this.translate.instant('success'), this.translate.instant('operation_successfull'), null, null)
      .then(close => {
        if(close) {
         trueBtn = true;
        }
      });
    } else {
      // tslint:disable-next-line: max-line-length
      await this.helperFunction.presentAlert('error', this.translate.instant('failed'), res.msg ? this.translate.instant(res.msg) : this.translate.instant('something_went_wrong'), null, null);
    }
     return new Promise((resolve, reject) => resolve(trueBtn))
  }

  changePerPage(ev, perpageInput, size) {
    let result;
    // console.log(ev, perpageInput, size)
    if (size > 0 && size < Number(perpageInput)) {
      // console.log(true)
      size = Number(perpageInput) - size;
      result = ['load-more', size];
    } else if (size > 0 && size > Number(perpageInput)) {
      size = Number(perpageInput);
      // console.log(false)

      result = ['', size];
    }
    return result;
  }

  editProvider(providerID, params: any): Promise<any> {
    return this.httpService.Post
      (`${this.configService.PROXIES.sport_admin_services}/provider/${encodeURIComponent(providerID)}/updateProvider`, params);
  }
  editPaymentAccount(id, params) {
    return this.httpService.Post
      (`${this.configService.GATEWAY_ADMIN_}/provider-service/customer/updateAccount/${encodeURIComponent(id)}`, params);
  }

 async sendNotificationContent(type:string, data: any) {
  // var api = "http://10.12.1.178:3001";
  var api = this.configService.GATEWAY_ADMIN_
    return await this.httpService.Post(
      `${api}/notifications/multichannel`, {data: data, type: type})
  }
}
